import React from 'react';
import Utilities from '@util/Utilities';
import { PaletteColors } from '@app/component/form/color/PaletteColors';

type SimpleColorPickerProps = {
	value?: string;
	onChange: (color: string) => void;
};

const SimpleColorPicker: React.FC<SimpleColorPickerProps> = ({ value = PaletteColors[0], onChange }) => {
	return (
		<div className="grid grid-cols-8 gap-2">
			{PaletteColors.map((color) => (
				<button
					key={color}
					type="button"
					onClick={() => onChange(color)}
					className={Utilities.classNames(
						'p-6 rounded flex items-center justify-center',
						value === color ? 'ring-2 ring-offset-2 ring-blue-500' : 'ring-1 ring-black ring-opacity-10',
					)}
					style={{ backgroundColor: color }}
				/>
			))}
		</div>
	);
};

export default SimpleColorPicker;
